import { InjectionToken } from "@angular/core";
/**
 * @type {symbol} DI provider token for {@link ReduxConfigService} implementations.
 */
export const ReduxConfigServiceToken: InjectionToken<ReduxConfigService> = new InjectionToken<ReduxConfigService>("core.redux.config");

/**
 * This service is a helper that collects all application redux reducers and build the reducer hierarchy from them. It
 * has only one public method, the `getRootReducer` that can be used when you create your application's redux store.
 */
export interface ReduxConfigService {
  /**
   * This method returns the reducer hierarchy of the application.
   *
   * @returns The root reducer function of the application.
   */
  getRootReducer(): Function;
}
